var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdeaGeneratorGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13, 7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 27.7143V25.8929C15.6667 23.692 18.076 21.6102 19.6389 20.125C21.8419 18.0327 23 15.2216 23 11.9286C23 5.85718 18.1317 1.00004 12 1.00004C10.5544 0.996036 9.12215 1.27598 7.78575 1.82377C6.44935 2.37156 5.23512 3.1764 4.21287 4.19201C3.19062 5.20762 2.38053 6.41396 1.82915 7.74169C1.27778 9.06941 0.99601 10.4923 1.00004 11.9286C1.00004 15.104 2.20775 18.1055 4.36115 20.125C5.91566 21.5829 8.33336 23.6692 8.33336 25.8929V27.7143M9.55558 35H14.4445M8.33336 31.3571H15.6667M12 27.7143V18",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaGeneratorGrey);
export default __webpack_public_path__ + "static/media/idea_generator_grey.12a00ba8c6b918725574c71f7a02e931.svg";
export { ForwardRef as ReactComponent };